import { callApi, HttpMethod } from "../../../utils/httpRequest";

const fetchHcfDetails = async (hcfId, field) => {
  if (!hcfId || !field) {
    return null;
  }

  const [res] = await callApi({
    method: HttpMethod.GET,
    url: `${global.api}/facilityprofile/details`,
    query: {
      facilityIds: hcfId,
      projection: field,
    },
  });
  return res;
};

export { fetchHcfDetails };
